import { ScannedWristbandError } from "../scan-validation/scan-validation-error";
import { ScanLogType } from "../../app.enums";
import { modalMessage } from "../../app.modal-messages";
import { IPatientValidation } from "../scan-validation/scan-validation.model";

/**
 * When a user has scanned a bottle/product twice.
 */
export function RejectDuplicatePatient() {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor
	) {
		const originalMethod = descriptor.value;

		descriptor.value = function (...args: IPatientValidation[]) {
			const [obj] = args;

			// destructure the object
			const { patient, patients } = obj;

			const isDuplicate = patients.some((p) => p.id === patient.id);
			if (isDuplicate) {
				throw new ScannedWristbandError({
					scanLogType: ScanLogType.Patient_Duplicate,
					modal: modalMessage.patient_duplicate(),
				});
			}

			return originalMethod.apply(this, args);
		};
	};
}
